
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "17px",
    "height": "6px",
    "viewBox": "0 0 17 6",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "箭头"
        }
      ]
    },
    {
      "tag": "desc",
      "children": [
        {
          "text": "Created with Sketch."
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "按标签查找事项",
            "transform": "translate(-1542.000000, -191.000000)",
            "fill": "#999999",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "编组-4",
                "transform": "translate(1470.000000, 183.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "箭头",
                    "transform": "translate(80.625000, 10.875000) rotate(-90.000000) translate(-80.625000, -10.875000) translate(77.625000, 2.375000)"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M1.40162874,3.6752823e-12 L1.40162874,13.2216508 L5.25,9.97688698 L5.25,11.7903573 L-2.40696352e-13,16.375 L0,9.09494702e-13 L1.40162874,3.6752823e-12 Z",
                        "id": "形状结合"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  